// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2HQui","colMin":"styles_colMin__17Q8K","colCheckbox":"styles_colCheckbox__1gp89"};